import { WeatherSettingsChangeSource } from '@fe/weather';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox, NumericTextBox } from '@progress/kendo-react-inputs';
import { MinimumPirepIcingOptions, MinimumPirepTurbulenceOptions } from '../settings-options';
import { useBooleanSetting, useDropdownSetting, useNumericSetting } from './hooks/useSetting';
import SettingsSubSection from '../../../common/SettingsSubSection';

export default function AirspaceSettings() {
    const changeSource = WeatherSettingsChangeSource.airspacePireps;
    const minTurbulence = useDropdownSetting(MinimumPirepTurbulenceOptions, 'airspace', 'minimumTurbulence', changeSource);

    const minIcing = useDropdownSetting(MinimumPirepIcingOptions, 'airspace', 'minimumIcing', changeSource);
    const showTurbulence = useBooleanSetting('airspace', 'showTurbulence', changeSource);
    const showIcing = useBooleanSetting('airspace', 'showIcing', changeSource);
    const showWeather = useBooleanSetting('airspace', 'showWeather', changeSource);
    const showWindShear = useBooleanSetting('airspace', 'showWindShear', changeSource);
    const minAltitude = useNumericSetting('airspace', 'minAltitude', changeSource);
    const maxAltitude = useNumericSetting('airspace', 'maxAltitude', changeSource);
    const maxReportTime = useNumericSetting('airspace', 'reportedLast', changeSource);

    const aircraftSmall = useBooleanSetting('airspace', 'aircraftSmall', changeSource);
    const aircraftLarge = useBooleanSetting('airspace', 'aircraftLarge', changeSource);
    const aircraftHeavy = useBooleanSetting('airspace', 'aircraftHeavy', changeSource);
    const aircraftUnknown = useBooleanSetting('airspace', 'aircraftUnknown', changeSource);

    const showFca = useBooleanSetting('airspace', 'showFca', WeatherSettingsChangeSource.airspaceFcaFea);
    const showFea = useBooleanSetting('airspace', 'showFea', WeatherSettingsChangeSource.airspaceFcaFea);
    const showFcaFsm = useBooleanSetting('airspace', 'showFcaFsm', WeatherSettingsChangeSource.airspaceFcaFea);
    const showFcaAfp = useBooleanSetting('airspace', 'showFcaAfp', WeatherSettingsChangeSource.airspaceFcaFea);

    const applyTransparencyTfrs = useBooleanSetting('airspace', 'tfrApplyTransparency', WeatherSettingsChangeSource.airspaceTfrs);

    return (
        <div className="d-flex flex-column gap-2">
            <SettingsSubSection title="FEA/FCA">
                <div>
                    <Checkbox {...showFea} label="FEAs" />
                    <Checkbox {...showFca} label="FCAs" />
                    <Checkbox {...showFcaFsm} label="FCAs (FSM eligable)" />
                    <Checkbox {...showFcaAfp} label="FCAs (AFP)" />
                </div>
            </SettingsSubSection>
            <SettingsSubSection title="PIREPs">
                <div className="d-flex gap-1 align-itemscenter">
                    <Checkbox {...showTurbulence}></Checkbox>
                    <div className="flex-grow-1">Turbulence - minimum:</div>
                    <DropDownList {...minTurbulence} style={{ width: 200 }} />
                </div>

                <div className="d-flex gap-1 align-items-center">
                    <Checkbox {...showIcing}></Checkbox>
                    <div className="flex-grow-1">Icing - minimum:</div>
                    <DropDownList {...minIcing} style={{ width: 200 }} />
                </div>

                <Checkbox className="py-1" {...showWeather} label="Weather & Skys" />
                <Checkbox className="py-1" {...showWindShear} label="LLWS" />

                <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', columnGap: '1rem' }}>
                    <NumericTextBox {...minAltitude} />
                    <div>&lt;= altitude &lt;=</div>
                    <NumericTextBox {...maxAltitude} />
                </div>

                <div className="d-flex gap-2 align-items-center">
                    <div className="flex-shrink-0">Reported within the past</div>
                    <NumericTextBox style={{ width: 200 }} {...maxReportTime} />
                    minutes.
                </div>

                <div className="d-flex gap-2">
                    <div>Aircraft weight class:</div>
                    <Checkbox {...aircraftSmall} label="Small" />
                    <Checkbox {...aircraftLarge} label="Large" />
                    <Checkbox {...aircraftHeavy} label="Heavy" />
                    <Checkbox {...aircraftUnknown} label="Unknown" />
                </div>
            </SettingsSubSection>

            <SettingsSubSection title="TFRs">
                <Checkbox {...applyTransparencyTfrs} label="Apply transparency to TFRs" />
            </SettingsSubSection>
        </div>
    );
}
